// Cookie consent focus trap
// The CookieFirst banner is third-party and does not manage keyboard focus
// on its consent layers (banner and preference center). We listen to
// cf_layer_ready (fired once a layer is fully rendered, with the layer
// element in event.detail) to move focus into it and mark the rest of the
// page inert so Tab cannot escape. On cf_consent we release.

const INERT_SELECTORS = ['.skip-to-main', '.container--wrapper', '.container--overlays']

function setPageInert(inert) {
  for (const selector of INERT_SELECTORS) {
    document.querySelectorAll(selector).forEach(element => {
      if (inert) {
        element.setAttribute('inert', '')
      } else {
        element.removeAttribute('inert')
      }
    })
  }
}

export default function cookieConsentFocusTrap() {
  window.addEventListener('cf_layer_ready', event => {
    const layer = event.detail
    if (!(layer instanceof HTMLElement)) return

    if (!layer.hasAttribute('tabindex')) {
      layer.setAttribute('tabindex', '-1')
    }

    setPageInert(true)
    layer.focus()
  })

  window.addEventListener('cf_consent', () => setPageInert(false))
}
